import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from "@/functions/Util";

export default class LicencaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let licenca = model;
        
        if (isNull(licenca.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(licenca.idlicencaerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
        }

        if (!validated) {
            this.showMessage(new Message("alert", 'msg-campos-obrigatorios', true));
        }
        
        return validated;
    }

}